export default __webpack_public_path__ + "static/media/airtank-2.70096984.svg";